/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityRelationResponse } from './MonitEntityRelationResponse';
import {
    MonitEntityRelationResponseFromJSON,
    MonitEntityRelationResponseFromJSONTyped,
    MonitEntityRelationResponseToJSON,
} from './MonitEntityRelationResponse';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityRelationResponse
 */
export interface MonitPaginatedEntityRelationResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityRelationResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityRelationResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityRelationResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityRelationResponse>}
     * @memberof MonitPaginatedEntityRelationResponse
     */
    results?: Array<MonitEntityRelationResponse>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityRelationResponse interface.
 */
export function instanceOfMonitPaginatedEntityRelationResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityRelationResponseFromJSON(json: any): MonitPaginatedEntityRelationResponse {
    return MonitPaginatedEntityRelationResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityRelationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityRelationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityRelationResponseFromJSON)),
    };
}

export function MonitPaginatedEntityRelationResponseToJSON(value?: MonitPaginatedEntityRelationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityRelationResponseToJSON)),
    };
}

